import { ITEM } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetItemTypeRequest extends IBaseRequest {
    id: string;
    systemId?: string;
    priceList?: string;
    date?: Date;
}

export class GetItemTypeRequest extends BaseRequest implements IGetItemTypeRequest {
    id: string;
    systemId?: string;
    priceList?: string;
    date?: Date;

  constructor(server: string, session: string, id: string, systemId?: string, priceList?: string, date?: Date) {
    super(server, session);
    this.id = id;
    this.systemId = systemId;
    this.priceList = priceList;
    this.date = date;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.systemId, 'systemId');
    parameters += this.makeNode(this.priceList, 'priceList');
    parameters += this.makeNode(this.date, 'date');
    return super.wrapperXml(ITEM.getItemType, parameters);
  }
}
